<template>
  <div class="card-box">
    <a class="pull-right" style="cursor: pointer;" @click="showAll()">Voir l'historique des services</a>
    <h4 class="header-title m-t-0 m-b-20">Services récents</h4>

    <div v-for="source in sources" :key="source.name">
      <h6 :class="['title-block', 'title-block-' + getSourceColor(source.name)]" @click="source.opened = !source.opened" style="cursor: pointer;">
        {{ source.label }} ({{ getServices(source.name).length }})
        <div class="pull-right">
          <i class="fa fa-chevron-down" v-if="source.opened"></i>
          <i class="fa fa-chevron-up" v-else></i>
        </div>
      </h6>
      <ul v-if="source.opened">
        <li v-for="service in getServices(source.name)" :key="service.id">
          <i :class="['text-' + getServiceStatus(service).color, 'fa', getServiceStatus(service).icon]"></i> {{ service.name }}

          <el-tooltip v-if="getServiceDateText(service) != ''" :content="getServiceDateText(service)" placement="top">
            <i class="fa fa-calendar" aria-hidden="true"></i>
          </el-tooltip>

          <div v-if="getServiceStatus(service).text != '' && getServiceStatus(service).color !== 'success'" :class="'text-' + getServiceStatus(service).color">
            {{ getServiceStatus(service).text }}
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import moment from 'moment'

  export default {
    name: 'customer-services-summary-widget',
    props: ['customer'],
    data () {
      return {
        sources: [
          {
            name: 'devis-b2b',
            label: 'Devis B2B',
            opened: true
          },
          {
            name: 'communication',
            label: 'Communication',
            opened: true
          }
        ],
        more: false
      }
    },
    methods: {
      showAll () {
        this.$emit('show', 'services')
      },
      getServices (source) {
        return this.customer.services
          .filter(service => service.source === source)
          .filter(service => {
            return !service.end_at || moment(service.end_at.date).diff(moment(), 'days') > -380
          })
      },
      getServiceStatus (service) {
        return this.$model.service.getStatus(service)
      },
      getServiceDateText (service) {
        let text = ''

        if (service.start_at) {
          text += 'Début ' + moment(service.start_at.date).format('DD/MM/YYYY') + '. '
        }
        if (service.end_at) {
          text += 'Fin ' + moment(service.end_at.date).format('DD/MM/YYYY') + '. '
        }

        return text
      },
      getSourceColor (source) {
        let color = 'success'
        let services = this.getServices(source)
        for (let i = 0; i < services.length; i++) {
          let service = services[i]

          if (!service.end_at || moment(service.end_at.date).diff(moment(), 'days') > -180) {
            let serviceColor = this.getServiceStatus(services[i]).color

            // If it is a danger, return danger directly
            if (serviceColor === 'danger') {
              return 'danger'
            }

            if (serviceColor === 'warning') {
              color = 'warning'
            }
          }
        }

        return color
      }
    }
  }
</script>



// WEBPACK FOOTER //
// CustomerServicesSummaryWidget.vue?01d42b12